import { ReactNode } from 'react'
import { AppButton } from '@clickguard/design-system'
import ChevronSelectorVertical from '@untitled-ui/icons-react/build/esm/ChevronSelectorVertical'

interface BreadcrumbTriggerProps {
	icon: ReactNode
	label: string
	onClick?: () => void
	isOpen?: boolean
}

export const BreadcrumbTrigger = ({
	icon,
	label,
	onClick,
	isOpen
}: BreadcrumbTriggerProps) => {
	return (
		<AppButton
			variant="secondary"
			size="sm"
			leftIcon={icon}
			rightIcon={<ChevronSelectorVertical className="size-4" />}
			label={label}
			onClick={onClick}
			className={isOpen ? 'bg-[var(--bg-hover)]' : undefined}
			// AppButton never shrinks (cg-shrink-0), which is right for a button
			// on its own. In the navbar the breadcrumbs share the row with the
			// fixed icons, so on a narrow screen the label ellipsizes instead of
			// pushing them off the edge. Inline, because a cg- class cannot be
			// overridden by a Tailwind one.
			style={{ flexShrink: 1, minWidth: 0 }}
		/>
	)
}
